import { status } from '@/alas';
import { defineComponent, onMounted } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        // ================
        //
        // mounted
        //
        onMounted(() => {
            if (status.fetch('user').$v.logged === false) {
                context.root.$router.push({
                    name: 'home'
                });
            }
        });
    }
});
